import { render, staticRenderFns } from "./ClassConvention.vue?vue&type=template&id=77a3e1b6&scoped=true&"
import script from "./ClassConvention.vue?vue&type=script&lang=js&"
export * from "./ClassConvention.vue?vue&type=script&lang=js&"
import style0 from "./ClassConvention.vue?vue&type=style&index=0&id=77a3e1b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a3e1b6",
  null
  
)

export default component.exports